import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { MenuItemWrapperDefault } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/index.default';
import type { MenuItemWrapperProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../../Button';

export interface DrawerMenuMenuItemWrapperProps extends MenuItemWrapperProps {
  setExpandedMenuItem: React.Dispatch<React.SetStateAction<string>>;
}

const DrawerMenuMenuItemWrapper: React.FC<DrawerMenuMenuItemWrapperProps> = (props) => {
  const {
    level,
    className,
    children,
    buildMenu,
    setExpandedMenuItem,
  } = props;

  const { t } = useTranslation();

  const layerClasses = c(`RecursiveMenu__layer__${level}`, className);

  if (level === 1) {
    return (
      <div className="DrawerMenu__Menu__overlay">
        <Container className="root-container">
          <div className="row">
            <div className="col-12">
              <div className="DrawerMenu__Menu__overlay__inner">
                <Button
                  className="DrawerMenu__Menu__overlay__back-button"
                  type="text"
                  icon="chevron_left"
                  iconPosition="left"
                  onClick={() => setExpandedMenuItem('')}
                >
                  {t('buttons.back')}
                </Button>

                <ul className={layerClasses}>
                  {children.map((item) => buildMenu(item))}
                </ul>
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <MenuItemWrapperDefault {...props} />
  );
};

export default DrawerMenuMenuItemWrapper;
